<template>
	<v-layout wrap class="banner" id="banner">
		<v-flex xs12 class="container">
			<v-layout wrap>
				<v-flex xs12 md4 class="banner-color">
					<v-flex class="center-logo">
						<button @click="goToHome">
							<img :src="`${$S3}logo-mibodega-white.png`" alt="Mi Bodega">
						</button>
					</v-flex>
					<v-flex class="banner-info">
						<div class="banner-information">
							<p>
								La primera App para ayudar a los <br/>negocios en  
								tiempo de Coronavirus.
							</p>
						</div>
						<h6 class="banner-top-title mb-2">CONOCE A MIBODEGA</h6>
						<p class="f-18"><span class="bold">MiBodega</span> es la forma más segura para que tus clientes 
							hagan sus pedidos, y <span class="special-text">así evitemos las colas y el contacto</span>. 
							Nacemos con el propósito de ayudar a nuestra comunidad, 
							acercando a clientes y negocios de manera segura.</p>
						<v-layout wrap class="banner-wrapper-points">
							<v-flex xs1>
								<img src="/static/images/banners/check.svg" alt="check">
							</v-flex>
							<v-flex 
								xs11 
								mb-2
								pl-2 
								class="f-18">Aumentarás tus ventas, fidelizarás a tus clientes y evitarás más contagios.</v-flex>
							<v-flex xs1>
								<img src="/static/images/banners/check.svg" alt="check">
							</v-flex>
							<v-flex 
								xs11 
								mb-2
								pl-2
								class="f-18">Es 100% personalizado a tu negocio: con tu marca y logo.</v-flex>
							<v-flex xs1>
								<img src="/static/images/banners/check.svg" alt="check">
							</v-flex>
							<v-flex 
								xs11 
								mb-4
								pl-2
								class="f-18">Muy sencillo de usar para ti y tus clientes de siempre.</v-flex>
						</v-layout>
						<div class="wrapper-promotion">
							<p>
								<span class="bold">Promoción de Lanzamiento:</span> Tenemos un regalo
								solo para los primeros {{ numberCoupon }} negocios valídados.
							</p>
						</div>
						<div>
							<a :href="guasapLink" target="_blank" class="banner-btn">
								<img src="/static/images/banners/whatsapp.svg" alt="whatsapp">
								<span class="btn-text">Deseo más información</span>
							</a>
						</div>
					</v-flex>
				</v-flex>
				<v-flex xs12 md6>
					<div class="wrapper-form">
						<div class="image-desktop">
							<img :src="`${$S3}phone-app-screen.png`" alt="app mi bodega" height="484">
						</div>
						<form-component 
							@open-modal="$emit('open-modal')"
							:cellar="cellar"
							:count="count"/>
					</div>
				</v-flex>
			</v-layout>
		</v-flex>
		
	</v-layout>
</template>

<script>
import { differenceInDays } from 'date-fns';
import formComponent from '@/components/home/form-component';

function created() {
	this.numberCoupon = process.env.NUMBER_COUPON;
	this.days = differenceInDays('2020/04/22', this.$today);
}

function guasapLink() {
	const userAgent = navigator.userAgent || navigator.vendor || window.opera;
	const regDeviceOne = /Android|webOS|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i;
	const regDeviceTwo = /iPad|iPhone|iPod/;
	if (regDeviceOne.test(userAgent)) {
		return `https://api.whatsapp.com/send?phone=${process.env.WHATSAPP_NUMBER}`;
	} else if (regDeviceTwo.test(userAgent) && !window.MSStream) {
		return `https://wa.me/${process.env.WHATSAPP_NUMBER}`;
	}
	return `https://web.whatsapp.com/send?phone=${process.env.WHATSAPP_NUMBER}`;
}

function data() {
	return {
		days: 0,
		numberCoupon: 0,
	};
}

export default {
	name: 'banner',
	data,
	components: {
		formComponent,
	},
	created,
	computed: {
		guasapLink,
	},
	props: {
		provinces: {
			type: Array,
			default: () => [],
		},
		cellar: {
			type: Object,
			default: () => {},
		},
		count: [Number, String],
	},
};
</script>
<style lang="scss" scoped>
	.banner {
		background-image: url('https://mibodega.s3-sa-east-1.amazonaws.com/BANNER+DESKTOP.png');
		background-color: map-get($colors, back-gray-l);
		background-position: 75% top;
		background-repeat: no-repeat;
		background-size: cover;
		font-family: font(lato-regular);
		justify-content: space-between;
		padding: 120px 8% 120px;
		position: relative;

		@media (max-width: 1340px) {
			padding: 110px 8% 125px;
		}

		@media (max-width: 934px) {
			background-image: none;
			padding: 0px;
		}

		&-color {
			@media (max-width: 934px) {
				background-image: url('https://mibodega.s3-sa-east-1.amazonaws.com/banner-mobile-d.png');
				background-position: center bottom;
				background-repeat: no-repeat;
				background-size: cover;
				padding: 63px 6% 410px;
			}
		}
	}

	.banner-info {
		color: color(white);
		font-size: 14px;

		@media (max-width: 959px) {
			text-align: center;
			width: 100%;
		}
	}

	.bold {
		font-family: font(lato-regular);
		font-weight: 600;
	}

	.banner-top-title {
		color: color(green-link);
		font-family: font(lato-regular);
		font-size: size(large30);
		font-weight: map-get($weight, w900);
		line-height: normal;

		@media (max-width: 959px) {
			font-size: size(large);
			margin: auto;
		}
	}

	.banner-btn {
		background: color(green-link);
		border-radius: 9px;
		color: color(white);
		display: inline-block;
		font-family: font(lato-regular);
		font-size: size(medium18);
		font-weight: map-get($weight, w900);
		padding: 12px 20px;
		text-decoration: none;
		text-align: center;

		&.desktop {
			@media (max-width: 959px) {
				display: none;
			}
		}

		&.mobile {
			display: none;

			@media (max-width: 959px) {
				display: inline-block;
				margin-bottom: 373px;
				padding: 8px 0;
				width: 233px;
			}
		}
	}

	.wrapper-form {
		align-items: center;
		display: flex;
		position: absolute;
		right: 16%;
		z-index: 1;

		@media (max-width: 959px) {
			margin-top: -173px;
			padding: 0 6%;
			position: relative;
			top: auto;
			right: auto;
		}
	}

	.center-logo {
		margin-bottom: 15px;

		@media (max-width: 959px) {
			margin-bottom: 20px;
			text-align: center;
		}

		img {
			height: 36px;

			@media (min-width: 934px) {
				height: 47px;
			}
		}
	}

	.wrapper-text {
		color: color(green-dark);

		p {
			margin-bottom: 30px;
		}

		@media (max-width: 959px) {
			background: color(white);
			border-radius: 8px;
			box-shadow: 0 2px 20px 0 rgba(7, 7, 7, 0.2);
			color: color(title);
			margin: auto;
			padding: 18px;
			max-width: 325px;
		}
	}

	.image-desktop {
		left: -195px;
		position: absolute;
		z-index: 2;

		@media (max-width: 1249px) {
			display: none;
		}
	}

	.wrapper-promotion {
		background: map-get($colors, info-text);
		border-radius: 4px;
		color: map-get($colors, white);
		font-family: font(lato-regular);
		font-size: map-get($sizes, medium18);
		margin-bottom: 25px;
		padding: 9px 16px;
	}

	.banner-information {
		font-size: map-get($sizes, medium15);
	}

	.f-18 {
		font-size: map-get($sizes, medium18);

		@media (max-width: 959px) {
			font-size: map-get($sizes, medium16);
		}
	}

	.banner-wrapper-points {
		display: none;

		@media (max-width: 959px) {
			background: color(white);
			border-radius: 8px;
			color: map-get($colors, title-green);
			margin-bottom: 15px;
			padding: 20px;
			text-align: left;
		}

		@media (max-width: 600px) {
			display: flex;
		}
	}

	.br-desktop {
		@media (max-width: 959px) {
			display: none;
		}
	}

	.special-text {
		color: color(green-link);
		font-weight: bold;
		font-style: italic;
	}
</style>


// WEBPACK FOOTER //
// src/components/home/banner.vue